import { gql } from '@apollo/client';

export const CRM_CONTACT_FIELDS = `
    _id
    accountId
    firstName
    lastName
    email
    phone
    jobTitle
    isPrimary
    tags
    notes
    marketingConsent {
        email
        sms
    }
    emailSubscribed
    unsubscribedAt
    createdAt
`;

export const LIST_CRM_CONTACTS = gql`
    query ListCrmContacts($accountId: String!) {
        listCrmContacts(accountId: $accountId) {
            ${CRM_CONTACT_FIELDS}
        }
    }
`;

export const LIST_ALL_CRM_CONTACTS = gql`
    query ListAllCrmContacts($input: ListCrmContactsInput!) {
        listAllCrmContacts(input: $input) {
            data {
                ${CRM_CONTACT_FIELDS}
                businessName
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

/**
 * The Contact profile (POGO-12603): core fields + business, emails sent,
 * bookings, training progress and tasks.
 */
export const GET_CRM_CONTACT_PROFILE = gql`
    query GetCrmContactProfile($contactId: ID!) {
        getCrmContactProfile(contactId: $contactId) {
            _id
            firstName
            lastName
            email
            phone
            tags
            emailSubscribed
            sourceUserId
            createdAt
            business {
                accountId
                businessName
                linkedBusinessId
                businessStatus
                status
            }
            emailsSent {
                _id
                subject
                status
                sentAt
                openedAt
                clickedAt
                opened
                clicked
                campaignId
            }
            bookings {
                _id
                title
                startAt
                endAt
                meetLink
                status
            }
            trainingProgress {
                status
                percentComplete
                moduleCounts {
                    total
                    todo
                    learning
                    needHelp
                    gotIt
                    na
                }
            }
            tasks {
                _id
                title
                dueAt
                status
            }
        }
    }
`;

export const LIST_CRM_CONTACT_NOTES = gql`
    query ListCrmContactNotes($input: ListCrmContactNotesInput!) {
        listCrmContactNotes(input: $input) {
            data {
                _id
                body
                authorId
                authorName
                isPinned
                createdAt
                updatedAt
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;
